/**
 * Lo que queda de la paleta anterior de este feature.
 *
 * `MODAL_BG`, `SURFACE_BG`, `GREEN` y `ORANGE` se fueron con AMARU-883: sus consumidores toman
 * ahora los valores de `theme/au-compat.ts`, que es la capa.
 *
 * **`RED` se queda** porque lo importan dos archivos que **no** son de este feature ni de ese run —
 * `gateCommon/utils/accents.tsx` y `gateCommon/utils/gateMovementState.tsx`, los dos del incremento
 * de la figura—. Borrarlo rompe el build; se va cuando la figura se porte.
 */
export const RED = '#923E4A';
